import { TextField, FormLabel } from "@mui/material";
import axios from "axios";
import { FunctionComponent, useEffect, useState } from "react";
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
interface I_InputCep {
  onChange?: (e: string) => void
  value?: string
  check?: boolean
}

const InputCep: FunctionComponent<I_InputCep> = ({ onChange, value: _val, check }) => {

  const [cepFormatter, setCepFormatter] = useState<string>();

  const [isValid, setIsValid] = useState<boolean | undefined>(undefined);

  const formatter = (_value: string) => {
    if (_value?.length <= 9) {
      let val = _value?.replace('-', '');
      setCepFormatter(`${val?.substring(0, 5)}-${val?.substring(5, 8)}`);
      onChange?.(val)
      if (check) {
        checkCep(val);
      }
      return;
    }
    return;
  }

  const checkCep = async (_val) => {
    if (_val?.length < 8) { setIsValid(undefined); return; }
    try {
      const req = await axios.get('https://viacep.com.br/ws/' + _val + '/json');
      const res = await req.data;
      if(res?.erro) {
        throw new Error(JSON.stringify(res?.erro))
      }
      setIsValid(true);
    } catch (error) {
      setIsValid(false);
    }
  }

  useEffect(() => {
    formatter(_val)
  }, [_val])

  return (<>
    <FormLabel>CEP</FormLabel>
    <TextField
      defaultValue={InputCep}
      size="small"
      value={cepFormatter}
      onChange={(value) => formatter(value?.target?.value)}
      InputProps={
        typeof isValid == typeof undefined ? null :
        {
          endAdornment: isValid ? <DoneAllRoundedIcon /> : <DangerousRoundedIcon />
        }
      }
      sx={{
        ".MuiInputBase-root": {
          bgcolor: '#fff'
        }
      }}
    />
  </>);
}

export default InputCep;
